/*
 * @Copyright:
 * -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office,All rights reserved.
 * -----------------------------------------------------------------------------------
 *
 * @Description: 手机号拦截弹窗计数器
 * #1810462 【黑产防范】注册增加异常手机号拦截https://ones.wps.cn/project/#/team/MuZLKcYe/task/SQpKQ7fRfTvuxXP8
 */
interface CounterState {
  count: number // 当前点击次数
  showDialog: boolean // 弹窗显示状态
}

export default {
  namespaced: true,
  state: (): CounterState => ({
    count: 0,
    showDialog: false,
  }),
  mutations: {
    INCREMENT(state) {
      state.count++
    },
    TOGGLE_DIALOG(state, isShow: boolean) {
      state.showDialog = isShow
      state.count = 0
    },
  },
  actions: {
    handleClick({ commit, state }, n: number) {
      commit('INCREMENT')
      // 当计数超过n时显示弹窗
      if (state.count > n) {
        commit('TOGGLE_DIALOG', true)
      }
    },
    closeDialog({ commit }) {
      commit('TOGGLE_DIALOG', false)
    },
  },
}
